var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visa-color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.747,
    height: 49.831,
    viewBox: "0 0 74.747 49.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 74.747,
    height: 49.831,
    rx: 2,
    fill: "#2a2a6c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "visa-logo",
    d: "M26.505,14.887a12.336,12.336,0,0,1-4.143-.748l.684-3.114a7.738,7.738,0,0,0,3.511.849q.176,0,.352-.008c1.034,0,2.212-.747,2.212-1.4,0-.633-.557-.98-1.931-1.774l-.042-.024c-1.363-.787-3.229-1.866-3.229-3.9C23.918,1.959,26.48,0,30.149,0a10.071,10.071,0,0,1,3.456.622l-.653,3.114a7.248,7.248,0,0,0-3-.654c-.224,0-.452.011-.675.032-1.075.128-1.556.7-1.556,1.214-.012.674.838,1.122,1.822,1.641,1.505.794,3.378,1.782,3.378,4.06l.065-.062C32.983,12.957,30.438,14.887,26.505,14.887Zm9.995-.121h0l-3.921,0L38.183,1.4A1.71,1.71,0,0,1,39.765.342h3.121L46,14.76l-3.424,0-.53-2.15H37.28l-.779,2.15Zm3.863-10.53L38.4,9.654l3.333-.031Zm-20.65,10.5H16.008L19.122.311h3.706L19.714,14.73Zm-8.252,0H7.476L4.361,3.24a1.654,1.654,0,0,0-.875-1.278A16.356,16.356,0,0,0,0,.748V.311H6.228A1.733,1.733,0,0,1,7.941,1.805L9.53,10.122,13.7.311h3.8l-6.04,14.42Z",
    transform: "translate(14.326 17.41)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaImage);
export default __webpack_public_path__ + "static/media/VisaImage.31f65ad050e69c875b63d295a5b84a43.svg";
export { ForwardRef as ReactComponent };